export const gamificationOptionTypes = [
  { id: 'NONE', name: 'NONE' },
  { id: 'CREDIT', name: 'CREDIT' },
  { id: 'COMMODITY', name: 'COMMODITY' },
  { id: 'SPIN', name: 'SPIN' },
];

export const FulfilmentAttrs = ['User', 'Supplier', '3 PL', 'Others'].map((d, i) => ({
  label: d,
  value: i+1,
}));

export const FulfilmentReasonTypes = ['Return', 'Exchange', 'Both'].map((d, i) => ({
  label: d,
  value: i+1,
}));

export const FulfilmentTypes = ['Genuine Return', 'Easy Return'].map((d, i) => ({
  label: d,
  value: i,
}));

export const ImageQCTypes = ['Product', 'User'].map((d, i) => ({
  label: d,
  value: i+1
}));

export const FulfilmentStatus = [
  { label: 'Active', value: true },
  { label: 'Deactivate', value: false },
];

export const pushTypeKeysList=[ 
  {label:null,value:null}, 
  {label:'TIMER',value:0}, 
  {label:'AUTO_CAROUSEL',value:1}, 
  {label:'INPUT_BUTTON',value:2}
];


export const createTemplateDefaultKeys = [
  {label:'screen',value:'screen', type:'text'}, 
  {label:'ddl',value:'ddl',type:'text'}, 
  {label:'image',value:'image',type:'text'}, 
  {label:'channel',value:'channel',type:'text'}, 
  {label:'collection_id',value:'collection_id',type:'text'}, 
  {label:'collection_name',value:'collection_name',type:'text'}, 
  {label:'web_view_title',value:'web_view_title',type:'text'}, 
  {label:'web_view_url',value:'web_view_url',type:'text'}, 
  {label:'landing_page_title',value:'landing_page_title',type:'text'}, 
  {label:'landing_page_id', value:'landing_page_id',type:'number'},
  {label:'catalog_listing_page_name', value:'catalog_listing_page_name',type:'text'},
  {label:'payload', value:'payload',type:'text'},
  {label:'catalog_listing_page_id', value:'catalog_listing_page_id',type:'number'},
  {label:'community_url', value:'community_url',type:'text'},
  { label: 'with_oauth', value: 'with_oauth', type:'text' },
  { label: 'hide_toolbar', value: 'hide_toolbar', type:'text' },
];
export const templateDefaultForSpecialPush = [
  [
    {label:'alt_ttl',value:'alt_ttl', type:'text'}, 
    {label:'alt_sb_ttl',value:'alt_sb_ttl', type:'text'}, 
    {label:'alt_msg',value:'alt_msg', type:'text'}, 
    {label:'alt_img',value:'alt_img', type:'text'}, 
    {label:'ddl',value:'ddl',type:'text'},
    {label:'image',value:'image',type:'text'}, 
  ],
  [
    {label:'ddl',value:'ddl',type:'text'},
    {label:'image',value:'image',type:'text'}, 
  ],
  [
    {label:'ddl',value:'ddl',type:'text'},
    {label:'image',value:'image',type:'text'}, 
  ]
];

export const CLIENT_LIST = [
  {label: 'ANDROID', value: 'ANDROID'},
  {label: 'WEB', value: 'WEB'},
  {label: 'IOS', value: 'IOS'},
];

export const STATUS_TYPE=['CREATED','LIVE','PAUSED','STOPPED','COMPLETED'];

export const ACCOUNT_HOLDER_NAME_REGEX = /^[a-zA-Z ]*$/;

export const IMAGE_UPLOAD_CDN_URL = 'https://images.meesho.com';

export const EXPERIMENTATION_ADMINS = [
  'deepak.sasikumar@meesho.com',
  'prabhu.om@meesho.com',
  'hitesh.jain@meesho.com',
  'shubhamn.patel@meesho.com',
  'ramiz.mehran@meesho.com',
  'gajendra.mahawar@meesho.com',
  'ishan.mujumdar@meesho.com',
  'neha.deekonda@meesho.com',
  'pranav.kushawaha@meesho.com',
  'muniyandi.j@meesho.com',
  'shivam.garg@meesho.com',
];

export const SUPPLIER_CREATION_ADMINS = [
  'tawqeer.mohammad@meesho.com',
  'shubham.sureka@meesho.com',
  'pratiksha.seth@meesho.com',
  'sri.harini@meesho.com',
  'mainusab.rajasab@meesho.com',
  'aryan.agarwal@meesho.com',
  'varijaa.r@meesho.com'
];

export const EXPERIMENT_CREATION_REASON = {
  EXPERIMENT_GOVERNANCE: 'Experiment - Governance',
  INTERNAL_EXPERIMENT: 'Experiment - Internal',
  ANON_EXPERIMENT: 'Experiment - Anon',
  SALE_RELATED_EXPERIMENT: 'Experiment - Sale',
  EXPERIMENT_WIDGET_GROUP: 'Experiment - Widget Group',
  EXPERIMENT_PUSH_NOTIFICATION: 'Experiment - Push Notification',

  PLATFORM_DATA_MEASUREMENT: 'Experiment - Multi-Type / Config',
  
  FEATURE_LAUNCH_RESELLER: 'Feature Launch - Reseller',
  FEATURE_LAUNCH_SUPPLIER: 'Feature Launch - Supplier',
  FEATURE_LAUNCH_WIDGET_GROUPS: 'Feature Launch - Widget Groups',
  FEATURE_LAUNCH_OTHERS: 'Feature Launch - Others',
  
  DS_EXPERIMENT: 'DS Experiment',
  SUPPLIER_EXPERIMENT: 'Supplier Experiment',
  
  REVERSE_AB_Experiment: 'Holdout',
  WHATSAPP_PUSH_CAMPAIGN: 'WhatsApp - Push Campaign',
  MARKETING_CAMPAIGN: 'Marketing Campaign',
  SCALE_UP: 'Scale Up',
  OTHERS: 'Others',
};

export const DYNAMIC_CLP_FIELDS={
  supplier_id: 'Supplier ID',
  offer_tags: 'Offer Tags',
};

// Allowed Creation Reason Types - only these two options are valid for new audiences
export const ALLOWED_CREATION_REASON_TYPES = [
  { label: 'Experiment', value: 'EXPERIMENT' },
  { label: 'Rollout', value: 'ROLLOUT' }
];
